
import React, { FC } from 'react';
import { AnswerType, Question, QuestionType } from './types';
import TextLabel from '../Misc/LText';

interface SurveyResponseValueProps {
  question: Question;
  answerValue: string | string[] | number | boolean | null;
}

const SurveyResponseValue: FC<SurveyResponseValueProps> = ({
  question,
  answerValue,
}) => {
  switch (question.questionType) {
    case QuestionType.BOOLEAN:
      return <TextLabel title={answerValue === '1' ? 'Sí' : 'No'} />
    case QuestionType.MULTIPLE:
      if (question.answerType === AnswerType.SINGLE) {
        return <TextLabel title={answerValue as string} />
      }

      return <TextLabel title={(answerValue as string[])?.join(', ')} />
    default:
      return <TextLabel title={answerValue as string} />
  }
};

export default SurveyResponseValue;
